import ProgramData from './models/ProgramData';
import QuestionData from './models/QuestionData';
import programs from './programs.json';
import questions from './questions.json';

const Data = { questions: questions as QuestionData[], programs: programs as ProgramData[] };

export default Data;
